import React, { useState, useEffect } from "react";
import { useTheme } from "@mui/material/styles";
import makeStyles from '@mui/styles/makeStyles';
import {
  Grid,
  Typography,
  TextField,
  FormControlLabel,
  Button,
  Checkbox,
  FormControl,
  InputLabel,
  Select,
  Radio,
  FormLabel,
  RadioGroup,
  MenuItem,
  Paper,
  FormGroup,
  Card,
  CardHeader,
  CardActions,
  CardContent,
  FormHelperText,
} from "@mui/material";
import Autocomplete from '@mui/material/Autocomplete';

import { useTranslation } from "react-i18next";
import { getARVFacilityList } from "../../../services/Common";

const DispenserFormData = ({
  errorObject,
  addProductForm,
  formData,
  handleChange,
  handleCheck,
  handleReset,
  handleSubmit,
  handleUpdate,
  ...props
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const [value, setValue] = useState(0);
  const { t, i18n } = useTranslation();

  //get DispensingLanguage
  const DispensingLanguage = JSON.parse(
    localStorage.getItem("DispensingLanguage")
  );
  const lan = localStorage.getItem("LangCode");
  const menukey = "dispenser";

  const TitleList = JSON.parse(localStorage.getItem("TitleList"));
  const PostList = JSON.parse(localStorage.getItem("PostList"));
  const RxLevelList = JSON.parse(localStorage.getItem("RxLevelList"));
  const CountryList = JSON.parse(localStorage.getItem("CountryList"));
  // const FacilityList = JSON.parse(localStorage.getItem("FacilityList"));
  const FacilityList = getARVFacilityList();
  const UserList = JSON.parse(localStorage.getItem("UserList"));
  const UserListEdit = JSON.parse(localStorage.getItem("UserListEdit"));

  //====== Start Choosen Dropdown===========
  const [chosenValues, setChosenValues] = useState({
    demander: null,
  });

  useEffect(() => {
    let chosenValuesData = { ...chosenValues };
    chosenValuesData["demander"] =
      (FacilityList.find(
          (FacilityList_list) => FacilityList_list.id == formData.demander
        ) ?? null);

    setChosenValues(chosenValuesData);
  }, [formData.demander]);

  const handleChangeChoosen = (name, valueobj, value) => {
    let chosenValuesData = { ...chosenValues };
    chosenValuesData[name] = valueobj;
    setChosenValues(chosenValuesData);
    props.handleChangeChoosenProps(name, value);
  };

  //====== End Choosen Dropdown===========

  function tabChangeHandler(event, newValue) {
    setValue(newValue);
  }

  const handleChangeIndex = (index) => {
    setValue(index);
  };

  const getRxLevel = (type = null) => {
    let level = "";

    if (formData.rxLevel) {
      level = formData.rxLevel;
    }
    return level;
  };

  return (
    <div className={classes.productPageTitle}>
      <div className="sw_makeStyles_tableContainer">
        <div className="d-flex justify-product mb-3">
          <Grid container>
          <Grid item xs={12} sm={12}>
            <div className="sw_page_heading">
              <div className="sw_heading_title">
                {DispensingLanguage[lan][menukey]["Dispenser - Add/Edit"]}
              </div>

              <div className="float-end sw_btn_control">
                {addProductForm ? (
                  <Grid item xs={12} className="mt-4 text-center">
                    <div className="float-end sw_btn_control">
                      <Button
                        disabled={!!props.permissionType}
                        className="me-2"
                        variant="contained"
                        color="gray"
                        type="reset"
                        onClick={() => handleReset()}
                      >
                        {DispensingLanguage[lan][menukey]["Reset"]}
                      </Button>
                      <Button
                        disabled={!!props.permissionType}
                        className="me-2"
                        variant="contained"
                        color="primary"
                        onClick={() => handleSubmit()}
                      >
                        {DispensingLanguage[lan][menukey]["Save"]}
                      </Button>
                      <Button
                        className="me-2"
                        variant="contained"
                        color="gray"
                        type="reset"
                        onClick={() => props.history.push("/dispenser")}
                      >
                        {DispensingLanguage[lan][menukey]["Back to List"]}
                      </Button>
                    </div>
                  </Grid>
                ) : (
                  <Grid item xs={12} className="mt-2 text-center">
                    <Button
                      disabled={!!props.permissionType}
                      className="me-2"
                      variant="contained"
                      color="primary"
                      onClick={() => handleUpdate()}
                    >
                      {DispensingLanguage[lan][menukey]["Update"]}
                    </Button>

                    <Button
                      className="me-2"
                      variant="contained"
                      color="gray"
                      type="reset"
                      onClick={() => props.history.push("/dispenser")}
                    >
                      {DispensingLanguage[lan][menukey]["Back to List"]}
                    </Button>
                  </Grid>
                )}
              </div>
            </div>
          </Grid>
          </Grid>
        </div>

        {/* New row */}
        <Grid container spacing={2}>
          {/* New row */}
          <Grid item xs={12} sm={12}>
            <Card className="sw_card">
              <CardHeader
                title={DispensingLanguage[lan][menukey]["Personal Information"]}
              />
              <CardContent>
                <Grid container spacing={2}>
                  <Grid item xs={4} sm={4}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={12}>
                        <TextField variant="standard"
                          disabled={!!props.permissionType}
                          error={!!errorObject.lastName}
                          helperText={errorObject.lastName}
                          required
                          id="lastName"
                          name="lastName"
                          label={DispensingLanguage[lan][menukey]["Last Name"]}
                          // value={formData.LastName || "Islam"}
                          value={formData.lastName}
                          fullWidth
                          autoComplete="family-name"
                          onChange={(e) => handleChange(e)}
                        />
                      </Grid>

                      <Grid item xs={12} sm={12}>
                        <TextField variant="standard"
                          disabled={!!props.permissionType}
                          error={!!errorObject.firstName}
                          helperText={errorObject.firstName}
                          required
                          id="firstName"
                          name="firstName"
                          label={DispensingLanguage[lan][menukey]["First Name"]}
                          // value={formData.FirstName || "Mahmudul"}
                          value={formData.firstName}
                          fullWidth
                          autoComplete="family-name"
                          onChange={(e) => handleChange(e)}
                        />
                      </Grid>

                      <Grid item xs={6} sm={6}>
                        <TextField variant="standard"
                          disabled={!!props.permissionType}
                          id="initial"
                          name="initial"
                          label={DispensingLanguage[lan][menukey]["Initial"]}
                          value={formData.initial}
                          fullWidth
                          autoComplete="family-name"
                          onChange={(e) => handleChange(e)}
                        />
                      </Grid>

                      <Grid item xs={6} sm={6}>
                        <FormControl variant="standard" className={classes.fullWidth}>
                          <InputLabel id="demo-simple-select-helper-label">
                            {DispensingLanguage[lan][menukey]["Title"]}
                          </InputLabel>
                          <Select
                            disabled={!!props.permissionType}
                            labelId="demo-simple-select-helper-label"
                            id="titler"
                            name="title"
                            value={formData.title}
                            fullWidth
                            onChange={(e) => handleChange(e)}
                          label={DispensingLanguage[lan][menukey]["Title"]}>
                            {TitleList.map((item, index) => {
                              return (
                                <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>
                              );
                            })}
                          </Select>
                        </FormControl>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item xs={4} sm={4}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={12}>
                        <TextField variant="standard"
                          disabled={!!props.permissionType}
                          id="professional"
                          name="professional"
                          label={
                            DispensingLanguage[lan][menukey]["Professional"]
                          }
                          value={formData.professional}
                          fullWidth
                          autoComplete="family-name"
                          onChange={(e) => handleChange(e)}
                        />
                      </Grid>

                      <Grid item xs={12} sm={12}>
                        <TextField variant="standard"
                          disabled={!!props.permissionType}
                          id="staff"
                          name="staff"
                          label={DispensingLanguage[lan][menukey]["Staff#"]}
                          value={formData.staff}
                          fullWidth
                          autoComplete="family-name"
                          onChange={(e) => handleChange(e)}
                        />
                      </Grid>

                      <Grid item xs={6} sm={6}>
                        <FormControl variant="standard" className={classes.fullWidth}>
                          <InputLabel id="demo-simple-select-helper-label">
                            {DispensingLanguage[lan][menukey]["Post"]}
                          </InputLabel>
                          <Select
                            disabled={!!props.permissionType}
                            error={!!errorObject.post}
                            labelId="demo-simple-select-helper-label"
                            id="post"
                            name="post"
                            value={formData.post}
                            fullWidth
                            onChange={(e) => handleChange(e)}
                          label={DispensingLanguage[lan][menukey]["Post"]}>
                            {PostList.map((item, index) => {
                              return (
                                <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>
                              );
                            })}
                          </Select>
                        </FormControl>
                      </Grid>

                      <Grid item xs={6} sm={6}>
                        <FormControl variant="standard" className={classes.fullWidth}>
                          <InputLabel id="demo-simple-select-helper-label">
                            {DispensingLanguage[lan][menukey]["Rx Level"]}*
                          </InputLabel>
                          <Select
                            disabled={!!props.permissionType}
                            error={!!errorObject.rxLevel}
                            labelId="demo-simple-select-helper-label"
                            id="rxLevel"
                            name="rxLevel"
                            value={formData.rxLevel}
                            fullWidth
                            onChange={(e) => handleChange(e)}
                          label={`${DispensingLanguage[lan][menukey]["Rx Level"]} *`}>
                            {RxLevelList.map((item, index) => {
                              return (
                                <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>
                              );
                            })}
                          </Select>
                          <FormHelperText error={!!errorObject.rxLevel}>
                            {errorObject.rxLevel}
                          </FormHelperText>
                        </FormControl>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item xs={4} sm={4}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={12}>
                        <Typography variant="body2" component="p">
                          {DispensingLanguage[lan][menukey]["Rx Level"]}
                        </Typography>
                        <span className="classDispenserLevel">
                          {formData.rxLevel}
                        </span>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>

                {/* New Row */}
                <Grid container spacing={2}>
                  <Grid item xs={2} sm={2}>
                    <TextField variant="standard"
                      /* disabled={!!props.permissionType} */
                      error={!!errorObject.number}
                      helperText={errorObject.number}
                      disabled
                      required
                      id="number"
                      name="number"
                      label={DispensingLanguage[lan][menukey]["Number"]}
                      value={formData.number}
                      fullWidth
                      autoComplete="family-name"
                      onChange={(e) => handleChange(e)}
                    />
                  </Grid>

                  <Grid item xs={4} sm={4}>
                    <FormControl className={classes.fullWidth}>
                      <Autocomplete
                        disabled={!!props.permissionType}
                        autoHighlight
                        id="demander"
                        options={FacilityList}
                        onChange={(event, valueobj) =>
                          handleChangeChoosen(
                            "demander",
                            valueobj,
                            valueobj ? valueobj.id : ""
                          )
                        }
                        getOptionLabel={(option) => option?.name ?? ""}
                            isOptionEqualToValue={(option, value) => value?.id == null || option?.id === value?.id}
                        value={chosenValues["demander"]}
                        renderOption={(props, option) => (
                          <li {...props} key={option.id ?? option.name}>
                            <Typography className="sw_fontSize">{option.name}</Typography>
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            value={formData.demander}
                            label={
                              DispensingLanguage[lan][menukey]["Demander"] +
                              " *"
                            }
                            variant="standard"
                            error={!!errorObject.demander}
                            helperText={errorObject.demander}
                            id="demander"
                            name="demander"
                            fullWidth
                          />
                        )}
                      />
                    </FormControl>

                    {/* <FormControl className={classes.fullWidth}>
                      <InputLabel id="demo-simple-select-helper-label">
                        {DispensingLanguage[lan][menukey]["Demander"]}*
                      </InputLabel>
                      <Select
                        error={!!errorObject.demander}
                        labelId="demo-simple-select-helper-label"
                        id="demander"
                        required
                        name="demander"
                        value={formData.demander}
                        fullWidth
                        onChange={(e) => handleChange(e)}
                      label={`${DispensingLanguage[lan][menukey]["Demander"]} *`}>
                        {FacilityList.map((item, index) => {
                          return (
                            <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>
                          );
                        })}
                      </Select>
                      <FormHelperText error={!!errorObject.demander}>
                        {errorObject.demander}
                      </FormHelperText>
                    </FormControl> */}
                  </Grid>
                  <Grid item xs={2} sm={2}>
                    <FormControl variant="standard" className={classes.fullWidth}>
                      <InputLabel id="demo-simple-select-helper-label">
                        {DispensingLanguage[lan][menukey]["User"]}
                      </InputLabel>
                      <Select
                        disabled={!!props.permissionType}
                        labelId="demo-simple-select-helper-label"
                        id="UserId"
                        name="UserId"
                        value={formData.UserId}
                        fullWidth
                        onChange={(e) => handleChange(e)}
                      label={DispensingLanguage[lan][menukey]["User"]}>
                        <MenuItem value="">
                          {DispensingLanguage[lan][menukey]["All User"]}
                        </MenuItem>

                        {/*UserList.map((item, index) => {
                          return (
                            <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>
                          );
                        })*/}

                        {addProductForm
                          ? UserList.map((item, index) => {
                              return (
                                <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>
                              );
                            })
                          : UserListEdit.map((item, index) => {
                              //if(formData.UserId==item.id)
                              return (
                                <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>
                              );
                            })}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={4} sm={4}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          disabled={!!props.permissionType}
                          color="primary"
                          checked={formData.active}
                          onChange={(e) => handleCheck(e)}
                          name="active"
                          value="no"
                        />
                      }
                      label={DispensingLanguage[lan][menukey]["Active"]}
                    />
                  </Grid>
                </Grid>
                {/* New Row */}

                {/* Contact Details */}
                <Grid container spacing={2}>
                  <Grid item xs={4} sm={4}>
                    <TextField variant="standard"
                      disabled={!!props.permissionType}
                      id="address1"
                      name="address1"
                      label={DispensingLanguage[lan][menukey]["Address"]}
                      value={formData.address1}
                      fullWidth
                      autoComplete="family-name"
                      onChange={(e) => handleChange(e)}
                    />
                  </Grid>

                  <Grid item xs={4} sm={4}>
                    <TextField variant="standard"
                      disabled={!!props.permissionType}
                      id="contactNumber"
                      name="contactNumber"
                      label={DispensingLanguage[lan][menukey]["Contact#"]}
                      value={formData.contactNumber}
                      fullWidth
                      autoComplete="family-name"
                      onChange={(e) => handleChange(e)}
                    />
                  </Grid>
                  <Grid item xs={4} sm={4}>
                    <TextField variant="standard"
                      disabled={!!props.permissionType}
                      id="emailWork"
                      name="emailWork"
                      label={DispensingLanguage[lan][menukey]["E-mail (Work)"]}
                      value={formData.emailWork}
                      fullWidth
                      autoComplete="family-name"
                      onChange={(e) => handleChange(e)}
                    />
                  </Grid>

                  <Grid item xs={2} sm={2}>
                    <TextField variant="standard"
                      disabled={!!props.permissionType}
                      id="city"
                      name="city"
                      label={DispensingLanguage[lan][menukey]["City"]}
                      value={formData.city}
                      fullWidth
                      autoComplete="family-name"
                      onChange={(e) => handleChange(e)}
                    />
                  </Grid>

                  <Grid item xs={2} sm={2}>
                    <FormControl variant="standard" className={classes.fullWidth}>
                      <InputLabel id="demo-simple-select-helper-label">
                        {DispensingLanguage[lan][menukey]["Country"]}
                      </InputLabel>
                      <Select
                        disabled={!!props.permissionType}
                        labelId="demo-simple-select-helper-label"
                        id="country"
                        name="country"
                        value={formData.country}
                        fullWidth
                        onChange={(e) => handleChange(e)}
                      label={DispensingLanguage[lan][menukey]["Country"]}>
                        {CountryList.map((item, index) => {
                          return (
                            <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={4} sm={4}>
                    <TextField variant="standard"
                      disabled={!!props.permissionType}
                      id="contactNumberEmergency"
                      name="contactNumberEmergency"
                      label={
                        DispensingLanguage[lan][menukey]["Cell (Emergency)"]
                      }
                      value={formData.contactNumberEmergency}
                      fullWidth
                      autoComplete="family-name"
                      onChange={(e) => handleChange(e)}
                    />
                  </Grid>
                  <Grid item xs={4} sm={4}>
                    <TextField variant="standard"
                      disabled={!!props.permissionType}
                      id="emailPersonal"
                      name="emailPersonal"
                      label={
                        DispensingLanguage[lan][menukey]["E-mail (Personal)"]
                      }
                      value={formData.emailPersonal}
                      fullWidth
                      autoComplete="family-name"
                      onChange={(e) => handleChange(e)}
                    />
                  </Grid>

                  <Grid item xs={4} sm={4}></Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default DispenserFormData;

const useStyles = makeStyles({
  productPageTitle: {
    marginTop: "60px",
    color: "white",
    padding: "10px",
  },
  tableContainer: {
    backgroundColor: "whitesmoke",
    borderRadius: "10px",
    padding: "2rem",
    color: "black",
  },
  fullWidth: {
    width: "100%",
  },
});
